import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { DatePipe } from "@angular/common";
import memo from "memo-decorator";
export let AppViewShortDatePipe = class AppViewShortDatePipe extends DatePipe {
    transform(value, args) {
        if (!value) {
            return "";
        }
        return super.transform(value, "yyyy/MM/dd") + " at " + super.transform(value, "HH:mm");
    }
};
__decorate([
    memo()
], AppViewShortDatePipe.prototype, "transform", null);
AppViewShortDatePipe = __decorate([
    Pipe({
        name: "appViewShortDate"
    })
], AppViewShortDatePipe);
